<template>
  <div :class="['sp_sound_bars', { 'sp_sound_bars_animated': isRecording, 'sp_sound_bars_static': !isRecording }]" :style="containerStyle">
    <div class="sp_sound_bar sp_sound_bar_1" :style="barStyle"></div>
    <div class="sp_sound_bar sp_sound_bar_2" :style="barStyle"></div>
    <div class="sp_sound_bar sp_sound_bar_3" :style="barStyle"></div>
  </div>
</template>

<script>
export default {
  name: "SoundBarsIcon",
  props: {
    isRecording: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: "20px",
    },
    barWidth: {
      type: String,
      default: "3px",
    },
    gap: {
      type: String,
      default: "3px",
    },
    color: {
      type: String,
      default: "currentColor",
    },
    recordingColor: {
      type: String,
      default: "currentColor",
    },
  },
  computed: {
    containerStyle() {
      return {
        height: this.height,
        gap: this.gap,
      };
    },
    barStyle() {
      return {
        width: this.barWidth,
        backgroundColor: this.isRecording ? this.recordingColor : this.color,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.sp_sound_bars {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sp_sound_bar {
  border-radius: 2px;
  transition: height 0.2s ease;
}

.sp_sound_bars_static .sp_sound_bar {
  &:nth-child(1) {
    height: 8px;
  }
  &:nth-child(2) {
    height: 14px;
  }
  &:nth-child(3) {
    height: 10px;
  }
}

.sp_sound_bars_animated .sp_sound_bar {
  animation-duration: 0.8s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
}

.sp_sound_bar_1 {
  animation-name: sound-wave-1;
}

.sp_sound_bar_2 {
  animation-name: sound-wave-2;
  animation-delay: 0.2s;
}

.sp_sound_bar_3 {
  animation-name: sound-wave-3;
  animation-delay: 0.4s;
}

@keyframes sound-wave-1 {
  0% {
    height: 4px;
  }
  100% {
    height: 16px;
  }
}

@keyframes sound-wave-2 {
  0% {
    height: 8px;
  }
  100% {
    height: 20px;
  }
}

@keyframes sound-wave-3 {
  0% {
    height: 6px;
  }
  100% {
    height: 14px;
  }
}
</style>
